import React from "react";
import Sidebar from "../components/Sidebar";
import "../styles/Vote.css"; // Create or update this CSS file for styling

const voteSites = [
  { name: "Vote Site 1", url: "#" },
  { name: "Vote Site 2", url: "#" },
  { name: "Vote Site 3", url: "#" },
  { name: "Vote Site 4", url: "#" },
  { name: "Vote Site 5", url: "#" },
];

const Vote = () => (
  <div className="content">
    <Sidebar />
    <div className="main-content">
      <h1>Vote</h1>
      <p>Vote for us to recieve rewards!</p>
      <div className="Vote-container">
      <div className="vote-reward-box">
        <img
          src="https://cdn-icons-png.flaticon.com/512/138/138292.png"
          alt="Coins"
          className="vote-coins-icon"
        />
        <span>Earn a Vote Coin for each site you vote on!</span>
      </div>
      <div className="vote-links-grid">
        {voteSites.map((site, idx) => (
          <a
            key={site.name}
            href={site.url}
            target="_blank"
            rel="noopener noreferrer"
            className="vote-link-btn"
          >
            {site.name}
            <span className="vote-link-icon" aria-label="external link">
              <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                <path fill="currentColor" d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42L17.59 5H14V3ZM5 5h7v2H7.41l9.3 9.29-1.42 1.42L5 7.41V14h2v-7H5V5Z"/>
              </svg>
            </span>
          </a>
        ))}
      </div>
      </div>
      </div>
    </div>
);

export default Vote;